import styled from '@xstyled/styled-components';
import React, { FC } from 'react';
import { animated, useSpring } from '@react-spring/web';
import ChevronIcon from '~/assets/icons/new_chevron.svg';

const Icon = styled(ChevronIcon)`
  fill: black;
`;

const Wrapper = animated(styled.div`
  width: 16px;
  height: 16px;
`);

export const Chevron: FC<{ expanded: boolean }> = ({ expanded }) => {
  const props = useSpring({
    to: { transform: expanded ? 'rotate(-90deg)' : 'rotate(0deg)' },
    from: { transform: 'rotate(0deg)' }
  });

  return (
    <Wrapper style={props}>
      <Icon />
    </Wrapper>
  );
};
